import { segment } from '@actions/analytics';
import { useEffect, useState } from 'react';
import { REFER_EXIT_INTENT_VIEWED } from '../../constants';
import ReferralFeedbackDialog from './ReferralFeedbackDialog';

const ReferralFeedbackContainer = ({
  setOpenFeedbackDialog,
  openFeedbackDialog,
  setFeedBackData,
  feedBackData,
  referralFeedbackData,
  routeUrl,
  segmentData,
  goalSegmentData,
  setShowToast
}) => {
  const [hasError, setHasError] = useState(null);
  useEffect(() => {
    segment.track(REFER_EXIT_INTENT_VIEWED, {
      ...goalSegmentData,
      is_referred_a_learner: segmentData.is_referred_a_learner,
      total_referrals: segmentData.total_referrals,
      voucher_amount: segmentData.voucher_amount,
      total_extension: segmentData.total_extension,
      referral_type: segmentData.referral_type
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ReferralFeedbackDialog
      setOpenFeedbackDialog={setOpenFeedbackDialog}
      openFeedbackDialog={openFeedbackDialog}
      setFeedBackData={setFeedBackData}
      feedBackData={feedBackData}
      referralFeedbackData={referralFeedbackData}
      routeUrl={routeUrl}
      hasError={hasError}
      setHasError={setHasError}
      segmentData={segmentData}
      goalSegmentData={goalSegmentData}
      setShowToast={setShowToast}
    />
  );
};

export default ReferralFeedbackContainer;
